export const infoEmail = 'info@docmoonlight.com';
export const technicalEmail = 'IT@docmoonlight.com';
export const beshoyEmail = 'bsoliman@docmoonlight.com';
export const mickEmail = 'mike.broce@gmail.com';
export const richardEmail = 'Rhanna@docmoonlight.com';
export const kiroEmail = 'k.isaac@docmoonlight.com';
export const ramezEmail = 'rmorcos@docmoonlight.com';

export const GENERAL_INQUIRIES_EMAILS = [
  mickEmail,
  richardEmail,
  kiroEmail,
];

export const RADIOLOGY_CENTERS_EMAILS = [
  richardEmail,
  beshoyEmail,
  ramezEmail,
];

export const INFUSION_CENTERS_EMAILS = [
  richardEmail,
  beshoyEmail,
  ramezEmail,
];

export const RESIDENTS_AND_FELLOWS_EMAILS = [
  mickEmail,
  richardEmail,
  kiroEmail,
];

export const PARTNER_CC_EMAILS = [
  ramezEmail,
  richardEmail,
  beshoyEmail,
];

export const CONTACT_CC_BY_TYPE: Record<string, string[]> = {
  Technical: [technicalEmail],
  Payment: [beshoyEmail],
  'General inquiries': GENERAL_INQUIRIES_EMAILS,
  'Radiology Centers': RADIOLOGY_CENTERS_EMAILS,
  'Infusion Centers': INFUSION_CENTERS_EMAILS,
  'Residents & Fellows': RESIDENTS_AND_FELLOWS_EMAILS,
};
